exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-survey-preview-window .mdl-card__supporting-text{width:100%;padding:0;max-height:10000px}#asseco-survey-preview-window iframe{width:100%;height:100%;border:0}", ""]);

// exports
